import React, { Fragment, useEffect, useState, useMemo } from "react";
import { CCollapse, CLink } from "@coreui/react";
import axios from "axios";
import moment from "moment";
import config from "../../config/config";
import DataTable from "react-data-table-component";
import Loader from "../Loader/Loader";
import { toastSuccess, toastError } from "../../common/Toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from "../../common/Constant";
import { Noimage } from "../../common/imagePath";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button, IconButton, MenuItem, Tooltip } from "@mui/material";

function ReviewList(props) {
  const [visibleFeaturedProducts, setVisibleFeaturedProducts] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("Token");
  const [products, setProducts] = useState(props.visibleCategoriesChange);

  const [validationErrors, setValidationErrors] = useState({});
  // CALLBACK
  const [reviewesList, setReviewesList] = useState([]);

  useEffect(() => {
    axios
      .get(`${config.ecommconfigBaseUrl}/ecomconfig/reviewlist`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setReviewesList(res.data.ResponseData);
        return res;
      });
  }, []);

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      size:"40",
    },
    {
      header: "Item ID",
      accessorKey: "Itemid",
      size:"40",
    },
    {
      header: "Customer ID",
      accessorKey: "Customerid",
      size:"40",
    },
    {
      header: "Ratings",
      accessorKey: "Ratings",
      size:"40",
    },
    {
      header: "Review",
      accessorKey: "Review",
    },
  ]);

  //UPDATE action
  const handleSaveUser = async ({ values, table }) => {
    axios
      .post(
        `${config.ecommconfigBaseUrl}/ecomconfig/reviewupsert`,
        {
          ID: values?.ID,
          Itemid: values?.Itemid,
          Customerid: values?.Customerid,
          Ratings: values?.Ratings,
          Review: values?.Review,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        toastSuccess("Review Edit Successfully Done");
        const data = [...reviewesList];
        const index = reviewesList.findIndex((el) => el.ID == values?.ID);
        data[index] = values;
        setReviewesList(data);
        table.setEditingRow(null); //exit editing mode
      });
  };

  //DELETE action
  const openDeleteFunction = (row) => {
    axios
      .post(
        `${config.ecommconfigBaseUrl}/ecomconfig/reviewdelete`,
        { ID: row?.id },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        toastSuccess("Review Delete Successfully Done");
        const deletedata = reviewesList.filter(
          (item, index) => index !== row.index
        );
        setReviewesList(deletedata);
      });
  };

  return (
    <>
      <Loader loading={loading} />
      <Fragment>
        <div className="card">
          <div className="card-header">
            <h5 className="card-title">
              <CLink
                className="link"
                onClick={() => {
                  setVisibleFeaturedProducts(!visibleFeaturedProducts);
                  setProducts(!!products);
                }}
              >
                Product Review List
              </CLink>
            </h5>
          </div>
          <CCollapse
            visible={visibleFeaturedProducts || props.visibleCategoriesChange}
          >
            <div class="card-body">
              <div
                className="table-responsive  mt-4"
                style={{ border: "1px solid rgba(0,0,0,.12)" }}
              >
                <MaterialReactTable
                  muiTableContainerProps={{
                    sx: { maxHeight: "fit-content" },
                  }}
                  columns={columns}
                  data={reviewesList}
                  enableRowActions
                  //   createDisplayMode={"row"} // ('modal', and 'custom' are also available)
                  editDisplayMode={"row"} // ('modal', 'cell', 'table', and 'custom' are also available)
                  enableEditing={true}
                  getRowId={(row) => row.ID}
                  //   onCreatingRowSave={handleCreateUser}
                  onEditingRowSave={handleSaveUser}
                  renderRowActions={({ row, table }) => (
                    <Box sx={{ display: "flex", gap: "1rem" }}>
                      <Tooltip title="Edit">
                        <IconButton onClick={() => table.setEditingRow(row)}>
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <IconButton
                          color="error"
                          onClick={() => openDeleteFunction(row)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  )}
                  initialState={{
                    density: "compact",

                    sorting: [{ id: "ID", desc: false }], //sort by state by default
                  }}
                />
              </div>
            </div>
          </CCollapse>
        </div>
      </Fragment>
    </>
  );
}

// SearchableDropdown
const SearchableDropdown = ({ callback }) => {
  const token = localStorage.getItem("Token");
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [tableData, setTableData] = useState([]);

  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    // Fetch data from an API
    const fetchData = async () => {
      if (inputValue != "") {
        axios
          .get(
            `${config.itemsBaseUrl}/items/searchitem?searchparam=${inputValue}`,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            }
          )
          .then((response) => {
            if (response != "" && response != null) {
              const data = response.data.ResponseData;
              if (data[0].ItemId > 0) {
                setSuggestions(data);
              } else {
                setSuggestions([]);
              }
            }
          })
          .catch((error) => {});
      } else {
        setSuggestions([]);
      }
    };

    fetchData();
  }, [inputValue]);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);

    if (!value) {
      setSuggestions([]);
    }
  };

  const handleInputClick = (
    // event,
    pItemId,
    pItemName,
    pDescription,
    pVariationId,
    pAttributeId,
    pUnitPrice,
    pCostPrice,
    pQuantity,
    pVariationName
  ) => {
    const selectedOption = {
      ItemID: pItemId,
      ItemName: pItemName,
      Description: pDescription,
      VariationID: pVariationId,
      Quantity: pQuantity,
      AttributeId: pAttributeId,
      UnitPrice: pUnitPrice,
      CostPrice: pCostPrice,
      VariationName: pVariationName,
    };

    //setTableData([...tableData, selectedOption]);
    setTableData(selectedOption);

    setInputValue("");
    setSuggestions([]);
  };

  useEffect(() => {
    const locationItemData = tableData;

    callback(locationItemData);
  }, [tableData]);

  // handleCallback();
  // callback(LocationItemData);

  return (
    <div className="container">
      <form>
        <div className="mb-3">
          {/* <input type="text" className="form-control" value={inputValue} onChange={handleInputChange} /> */}
          <div className="input-group flex-nowrap">
            <span className="input-group-text" id="addon-wrapping">
              <a href="google.com">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fill-rule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                  />
                </svg>
              </a>
            </span>

            <input
              type="text"
              className="form-control h-auto"
              placeholder="Type item name or scan barcode"
              value={inputValue}
              onChange={handleInputChange}
            />
          </div>
        </div>
        {suggestions.length > 0 ? (
          <div className="dropdown">
            <ul
              className="dropdown-menu w-100 show"
              style={{ "max-height": "400px", overflow: "auto" }}
            >
              {suggestions.map((item) => (
                <li
                  key={item.ItemId}
                  onClick={(e) =>
                    handleInputClick(
                      item.ItemId,
                      item.ItemName,
                      item.Description,
                      item.VariationId,
                      item.AttributeId,
                      item.UnitPrice,
                      item.CostPrice,
                      item.itemquantity,
                      item.VariationName
                    )
                  }
                >
                  <a
                    key={item.ItemId}
                    href="#"
                    className="dropdown-item"
                    data-name={item.ItemName.toLowerCase()}
                    // onClick={handleInputClick(item.ItemId,item.ItemName)}
                  >
                    <img
                      src="https://th.bing.com/th/id/OIP.ADcGkW6WTfq2zu8yoY8vlgHaHa?w=197&h=197&c=7&r=0&o=5&pid=1.7"
                      alt={item.ItemName}
                      className="img-thumbnail rounded-circle mr-5"
                      style={{
                        maxWidth: "55px",
                        maxHeight: "55px",
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = Noimage;
                      }}
                    />
                    <div className="customer-info ml-2  ">
                      <h6 className="name">
                        {item.ItemName}
                        {item.VariationName ? `(${item.VariationName})` : ""}
                      </h6>
                      <div>
                        Unit Price: {parseFloat(item.UnitPrice).toFixed(2)} |
                        Qty: {parseInt(item.itemquantity)} <br />
                        Categories: {item.CategoryName}
                      </div>
                      {/* Add any other customer details here */}
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          ""
        )}
      </form>
    </div>
  );
};
// SearchableDropdown

export default ReviewList;
